import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We make sure a Buyer is happy before giving the Seller their 95% winnings. HostJane takes a 5% cut from all sales to cover costs of running HostJane. Here's who, what, where, when, why and how we pay.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      